import fieldName from './formFields';

const texts = {
  title: 'Workout Designer',
  addWorkout: 'Add New Workout',
  editWorkout: 'Edit Workout',
  editWorkoutAssignment: 'Edit Workout Assignment',
  editScheduledWorkout: 'Edit Scheduled Workout',
  assignmentUpdateModalTitle: 'Update Workout Assignments',
  assignmentUpdateOptionLabel: {
    SELECTED_ASSIGNMENT: 'Update only selected "{workoutName}" assignment',
    NOT_COMPLETED_ASSIGNMENTS: 'Update {count} incomplete "{workoutName}" assignments',
  },
  workoutCreated: 'The workout “{workoutName}” has been successfully created',
  workoutUpdated: `The workout “{workoutName}” has been successfully updated, 
                    and associated assignments have also been updated`,
  saveFailed: 'Failed to save the {type}. Please try again.',
  workoutAssignmentUpdated: 'The workout assignment “{workoutName}” has been updated successfully',
  workoutAssignmentsUpdated: '{count} “{workoutName}” Workout Assignments have been updated successfully',
  scheduledWorkoutUpdated: `The scheduled workout “{workoutName}” has been updated successfully,
                    and will be assigned with your changes`,
  actionConfirmMessage: `This action will update the un-started assignments 
                          related to this workout for all clients. Would you like to proceed?`,
  draftSaveConfirmMsgTitle: '{reason}, would you like to save this workout as a draft?',
  draftSaveConfirmMsgContent: 'Draft workouts are not eligible for assignment',
  draftSavingWarningMsg: 'Cannot update the {type}: {reason}',
  workout: 'workout',
  workoutAssignment: 'workout assignment',
  scheduledWorkout: 'scheduled workout',
  validation: {
    requiredField: 'Required',
  },
  saveNewButton: 'Save as New Workout',
  submitButton: {
    saveWorkout: 'Save Workout',
    saveWorkoutAssignment: 'Save Workout Assignment',
    saveScheduledWorkout: 'Save Scheduled Workout',
    updateWorkoutAssignments: 'Update Workout Assignments',
  },

  cancelButton: 'Cancel',
  field: {
    [fieldName.NAME]: {
      label: 'Workout Name',
    },
    [fieldName.NOTE]: {
      label: 'Workout Description',
    },
    [fieldName.DURATION]: {
      label: 'Duration',
    },
  },
  sessionType: {
    label: 'Session type',
    STANDARD: 'Standard workout',
    LONG_SESSION: 'Long-format session',
  },
  longSession: {
    saveDetails: 'Save Details',
    discardWorkout: 'Discard Workout',
    discardConfirmTitle: 'Discard this session?',
    discardConfirmContent: 'The session will be archived and will no longer appear in your workouts.',
    discardFailed: 'Could not discard the session. Please try again.',
  },
  sharedWorkoutSuffix: '(copy)',
  navConfirmTitle: 'Unsaved changes',
  navConfirmDescription: 'You have unsaved changes. Do you want to save before leaving?',
  zeroDuration: '0s',
  durationAutoHint: 'Auto: {duration}',
  workoutId: 'Workout ID',
  clipboardLabel: '{type} in clipboard',
};

export default texts;
